const MONITORINGS_TASKS = 'monitoringsTasks'
const MONITORINGS_LISTS = 'monitoringsLists'
const MONITORING_VALIDATIONS = 'monitoringValidation'
const TRANSLATIONS = 'translations'

export const MONITORINGS_TASKS_KEY = {
  tasksItems: MONITORINGS_TASKS + 'Items',
  tasksItem: MONITORINGS_TASKS + 'Item',
  tasksItemPhotos: MONITORINGS_TASKS + 'ItemPhotos',
  tasksResults: MONITORINGS_TASKS + 'TasksResults',
  tasksItemResults: MONITORINGS_TASKS + 'TasksItemResults',
  tasksValidationsConfigItems: MONITORINGS_TASKS + 'ValidationsConfigItems',
  tasksItemResultsComments: MONITORINGS_TASKS + 'TasksItemResultsComments',
  taskLogs: MONITORINGS_TASKS + 'logs'
} as const

export const MONITORINGS_CREATING_TASKS_KEY = {
  monitoringsCreatingTasksItems: 'monitoringsCreatingTasksItems',
  monitoringsTotalCreatingTasksItems: 'monitoringsTotalCreatingTasksItems'
} as const

export const MONITORINGS_LISTS_KEY = {
  currentListItems: MONITORINGS_LISTS + 'CurrentItems',
  currentListItem: MONITORINGS_LISTS + 'CurrentItem',
  archivesListItems: MONITORINGS_LISTS + 'ArchivesItems',
  archivesListItem: MONITORINGS_LISTS + 'ArchivesItem',
  listsItemProducts: MONITORINGS_LISTS + 'ItemProducts',
  listsSummary: MONITORINGS_LISTS + 'ListsSummary',
  listSummary: MONITORINGS_LISTS + 'ListSummary',
  rolesDirectors: MONITORINGS_LISTS + 'RolesDirectors',
  productHierarchy: MONITORINGS_LISTS + 'ProductHierarchy',
  quotas: MONITORINGS_LISTS + 'Quotas',
  promotion: MONITORINGS_LISTS + 'Promotion'
} as const

export const CATALOG_PRODUCTS_KEY = {
  productsList: 'catalogProductsList'
} as const

export const CATALOG_KEY = {
  trendsItems: 'catalogTrendsItems',
  purchasingGroupsItems: 'purchasingGroupsItems',
  commodityGroupsItems: 'commodityGroupsItems',
  categoriesItems: 'categoriesItems',
  subcategoriesItems: 'subcategoriesItems',
  statusItems: 'statusItems',
  confirmedProductsItems: 'confirmedProductsItems'
} as const

export const MONITORINGS_TYPES_KEY = {
  typesItems: 'monitoringsTypesItems',
  kindsItems: 'monitoringsKindsItems',
  typesExcludePromoItems: 'typesExcludePromoItems'
} as const

export const MONITORINGS_SUBTYPES_KEY = {
  subtypesItems: 'monitoringsSubtypesItems'
} as const

export const CONTRACTORS_KEY = {
  contractorsItems: 'contractorsItems',
  contractorsClustersItems: 'contractorsClustersItems'
} as const

export const MONITORING_SCHEDULE_KEY = {
  monitoringScheduleItems: 'monitoringScheduleItems'
}

export const LOCATION_KEY = {
  locationStoresItems: 'locationStoresItems',
  locationRegionsItems: 'locationRegionsItems',
  locationClustersItems: 'locationClustersItems',
  locationClusterGroupsItems: 'locationClusterGroupsItems',
  locationSalesOrganizationsItems: 'locationSalesOrganizationsItems',
  locationCompetitorsItems: 'locationCompetitorsItems',
  locationCompetitorsNetworksItems: 'locationCompetitorsNetworksItems'
} as const

export const QUOTAS_REPORTS_KEY = {
  quotaReportItems: 'quotaReportsItems'
} as const

export const EXTERNAL_PRODUCTS_CATALOG_KEY = {
  externalProductsList: 'externalProductsList',
  externalProductsListItem: 'externalProductsListItem',
  externalSearchLentaProductsList: 'externalSearchLentaProductsList',
  externalSearchProductsList: 'externalSearchProductsList',
  dependentProductsList: 'dependentProductsList'
} as const

export const PRODUCT_MERGE_KEY = {
  productMergeItems: 'productMergeItems'
} as const

export const MONITORINGS_TYPES_WITH_SUBTYPES_KEY = {
  monitoringsTypesWithSubtypesItems: 'monitoringsTypesWithSubtypesItems'
} as const

export const TEMPLATES_EDITOR_KEY = {
  templatesEditorItems: 'templatesEditorItems'
}

export const PRODUCTS_LENTA_KEY = {
  productNameItems: 'productNameItems',
  purchasingGroupsItems: 'purchasingGroupsItems',
  commodityGroupsItems: 'commodityGroupsItems',
  categoriesItems: 'categoriesItems',
  subcategoriesItems: 'subcategoriesItems'
}

export const INTERNAL_TASKS_KEY = {
  internalTasksItems: 'internalTasksItems',
  internalTasksItem: 'internalTasksItem',
  internalTasksItemComments: 'internalTasksItemComments',
  internalTasksExecutorItems: 'internalTasksExecutorItems'
} as const

export const COMMENT_SAMPLES = {
  commentSamplesItems: 'commentSamplesItems'
}

export const TRANSLATIONS_CONFIG_KEY = {
  config: TRANSLATIONS + 'Config',
  competitors: TRANSLATIONS + 'Competitors',
  monitoringTypes: TRANSLATIONS + 'MonitoringTypes',
  clusters: TRANSLATIONS + 'Clusters',
  superAbnormalConfig: TRANSLATIONS + 'SuperAbnormalConfig'
} as const

export const MONITORING_VALIDATION_KEY = {
  resultsConfig: MONITORING_VALIDATIONS + 'ResultsConfig',
  config: MONITORING_VALIDATIONS + 'Config',
  specialCases: MONITORING_VALIDATIONS + 'SpecialCases',
  priceRestoration: MONITORING_VALIDATIONS + 'PriceRestoration',
  storesLinks: MONITORING_VALIDATIONS + 'StoresLinks',
  promoPriceTransitions: MONITORING_VALIDATIONS + 'PromoPriceTransitions'
} as const

export const INTERNAL_TASKS_NOTIFICATION_KEY = {
  internalTasksNotification: 'internalTasksNotification'
}

export const AUTH_QUERY_KEY = {
  authUser: 'authUser'
}

export const PRICING_KEY = {
  productPricingListItems: 'productPricingListItems',
  pricingConfig: 'pricingConfig',
  pricingLevel: 'pricingLevel'
} as const

export const CLASSIFIER_CONTROLS_KEY = {
  classifierListItems: 'classifierListItems',
  classifierCategoryListItems: 'classifierCategoryListItems'
} as const
